class HeaderHome {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("alpinePage", () => ({
                    isScrolled: false,

                    init() {
                        window.addEventListener("scroll", () =>
                            this.onScroll(),
                        );
                    },

                    onScroll() {
                        this.isScrolled = window.pageYOffset >= 50;
                    },
                }));
            },
            { once: true },
        );
    }
}

new HeaderHome();
